import React from "react";
import { BulbOutlined, MoonOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useTheme } from "../ThemeContext";

const ToggleButton = styled.button`
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  border-radius: 11px;
  background: var(--surface);
  color: var(--text-secondary);
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: var(--secondary-teal);
    color: var(--secondary-teal);
    background: var(--secondary-teal-soft);
  }
`;

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <ToggleButton
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
    >
      {isDark ? <BulbOutlined /> : <MoonOutlined />}
    </ToggleButton>
  );
};
